import { all, takeLatest, call, put } from 'redux-saga/effects';
import { types, actions } from './module';
import { axiosInstance } from '../../services/helpers/axios';
import { StopType, Address, GetClosestLocationV2Input } from '../../apiTypes';

async function getClosestLocation(params: GetClosestLocationV2Input) {
    try {
        const { data } = await axiosInstance.get(`/geolocation/addresses/${params.placeId}`, { params });
        return data;
    } catch (error) {
        console.warn('Error on geolocation/addresses/closest', error);
        return error;
    }
}

function* onSearchClosestAddress(action) {
    const { payload, onError } = action;
    const { address, stopType } = payload;
    const { place_id: placeId } = address;
    const data = yield call(getClosestLocation, { placeId });
    if (data?.details) {
        // const { name, ...rest }: Address = data;
        // const address: Address = { ...rest };
        const addressClosestLocation: Address = data;
        addressClosestLocation.name = address.details.name;
        if (addressClosestLocation.poi) {
            addressClosestLocation.type = addressClosestLocation.poi.type;
        }
        yield put(
            stopType === StopType.PICKUP
                ? actions.setPickupAddress(addressClosestLocation)
                : actions.setDropOffAddress(addressClosestLocation),
        );
        if (stopType === StopType.PICKUP && addressClosestLocation.poi) {
            yield put(actions.setPOI(addressClosestLocation.poi));
        } /* else if (stopType === StopType.DROP_OFF && addressClosestLocation.poi) {
            yield put(actions.setPOIDropOff(addressClosestLocation.poi));
        } */
    } else {
        onError?.(data);
    }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function* currentBookingSaga() {
    yield all([takeLatest(types.SEARCH_LOCATION_CLOSEST, onSearchClosestAddress)]);
}

export default currentBookingSaga;
